<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Add a member</h1>
        </template>
        <div class="my-4 w-full">
            <label for="address" class="font-bold">What's their email address?</label>
            <input type="text" name="address" id="address" class="my-1 border border-gray-dark border-b-2 p-2 rounded w-full" placeholder="johndoe@example.com" v-model="email">
            <p class="text-destructive" v-if="errors.email && errors.email.length > 0">{{ errors.email[0] }}</p>
        </div>
        

        <template v-slot:footer>
            <progressable-button
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                :loading="loading"
                state="Adding..."
                @click.native="submit"
            >
                Add
            </progressable-button>
            <button class="ml-2 py-2 px-4 rounded-md bg-primary-lightest" @click="close">Cancel</button>
        </template>
    </modal-component>
</template>

<script>
export default {
    props: {
        team: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            email  : '',
            loading: false,
            errors : {}
        }
    },
    methods: {
        submit() {
            this.errors = {};
            this.loading = true;
            axios.post(`/api/teams/${this.team.id}/users`, {
                email  : this.email,
            }).then(response => {
                this.$emit('resolve');
            }).catch(error => {
                this.errors = error.response.data.errors;
            }).then(() => {
                this.loading = false;
            })
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>